module.exports = __webpack_public_path__ + "img/AS.faff9669.svg";